import React from "react";
import { connect } from "react-redux";
import {
  reduxForm,
  formValueSelector,
  change,
  submit,
  SubmissionError,
  stopSubmit,
  destroy,
} from "redux-form";
import validate from "./validate";
import PickupFormComponent from "./component";
import {
  nextStep,
  previousStep,
  setFormData,
  resetFormData,
  pickupBlocksApi,
} from "../pickup-form.actions";
import { getPickupBlockByType } from "utils/helpers";
import Tracking from "utils/tracking";
/*
 *
 * Set Initial Values
 * Set any default values for this form here, they will be passed to redux form
 **/

// import {logout} from 'actions/donor-login.actions'
let initialValues = {};

const thisForm = "publicPickupForm";

const mapStateToProps = (state, ownProps) => {
  const selectForm = formValueSelector(thisForm);
  const { pickupBlocks } = state.donorWizard;
  const { pickupTypes } = state.pickupTypes;

  const pickupTypesAvailable = [];

  pickupTypes.map((item) => {
    if (getPickupBlockByType(pickupBlocks, item).length > 0) {
      pickupTypesAvailable.push(item);
    }
  });

  // Sort pickupTypes by ID
  pickupTypesAvailable.sort((a, b) => (a.id > b.id ? 1 : -1));

  const onlyOnePickupType =
    pickupTypesAvailable.length == 1 ? pickupTypesAvailable[0] : null;

  const props = {
    formValues: state.donorWizard.formValues,
    user: state.donorWizard.formValues.user || null,
    location: state.donorWizard.formValues.location || null,
    pickupBlocks: state.donorWizard.pickupBlocks,
    addressSelected: state.donorWizard.formValues.mapAddress || null,
    pickupTypesId: selectForm(state, "pickupTypesId"),
    zipCode: state.donorWizard.formValues.zipCode || null,
    pickupTypes,
    pickupTypesAvailable,
    onlyOnePickupType,
  };
  if (pickupTypesAvailable.length) {
    initialValues = {
      ...initialValues,
      pickupTypesId: pickupTypesAvailable[0].id.toString(),
    };
  }
  return { initialValues, ...props };
};

const mapDispatchToProps = (dispatch) => {
  const handleSubmit = (form) => (dispatch) =>
    new Promise((resolve, reject) => {
      // has Furniture Value is a string so it needs to be converted to boolean

      dispatch(
        setFormData({
          pickupTypesId: form.pickupTypesId,
        })
      );
      resolve();
    });

  return {
    setFormData: (data) => dispatch(setFormData(data)),
    onSubmit: (form) => dispatch(handleSubmit(form)),
    previousStep: () => dispatch(previousStep()),
    onSelect: (id) => {
      dispatch(change(thisForm, "pickupTypesId", id));
      window.scrollTo(0, 9999);
    },
    onSubmitSuccess: () => {
      Tracking.track("Step 2: Logged : Pickup Type Chosen");
      return dispatch(nextStep());
    },
  };
};

// Create a component which injects redux form state, also handles handleSubmit of the underlying form component
const withForm = reduxForm({
  form: thisForm,
  destroyOnUnmount: false,
  validate,
})(PickupFormComponent);

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(withForm);

// Export Complete wrapper component ( Inject Reducer -> Connect -> Redux-Form -> Component )
export default withConnect;
